<script>
import { iBadge, iSpinner, iFeaturedIcon } from '@inscribe/signal';
import { RISK_LEVEL, riskLevelToReadableLabel } from '@/constants/riskLevels';
import StatusBadge, {
  StatusStyles,
} from '@/V2/components/status/StatusBadge.vue';
import { Statuses } from '@/V2/components/status/utils';

export default {
  name: 'RiskBadge',
  components: {
    iBadge,
    iSpinner,
    iFeaturedIcon,
    StatusBadge,
  },
  props: {
    riskLevel: {
      type: String,
      required: true,
    },
    class: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      Statuses,
      StatusStyles,
      riskLevelToReadableLabel,
    };
  },
  computed: {
    state() {
      switch (this.riskLevel) {
        case RISK_LEVEL.HIGH:
          return Statuses.ERROR;
        case RISK_LEVEL.MEDIUM:
          return Statuses.WARNING;
        case RISK_LEVEL.LOW:
          return Statuses.SUCCESS;
        case RISK_LEVEL.NOT_APPLICABLE:
        default:
          return Statuses.NEUTRAL;
      }
    },
  },
};
</script>
<template>
  <div :class="class">
    <status-badge
      :type="StatusStyles.SOLID"
      :state="state"
      :label="riskLevelToReadableLabel(riskLevel)"
    />
  </div>
</template>
